import { render, staticRenderFns } from "./EverydayTrafficLight.vue?vue&type=template&id=5a9b3f72&scoped=true&"
import script from "./EverydayTrafficLight.vue?vue&type=script&lang=ts&"
export * from "./EverydayTrafficLight.vue?vue&type=script&lang=ts&"
import style0 from "./EverydayTrafficLight.vue?vue&type=style&index=0&id=5a9b3f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b3f72",
  null
  
)

export default component.exports